import { render, staticRenderFns } from "./selfBuildModal.vue?vue&type=template&id=feb0c5e8&scoped=true"
import script from "./selfBuildModal.vue?vue&type=script&lang=js"
export * from "./selfBuildModal.vue?vue&type=script&lang=js"
import style0 from "./selfBuildModal.vue?vue&type=style&index=0&id=feb0c5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb0c5e8",
  null
  
)

export default component.exports